import { ProgrammeTypes } from '../../../constants';
import type {
  PreliminaryCheck,
  AdmissionRequirementValue,
} from '../../../graphql/NominationForm';

export type AdmissionRequirementBoxProps = {
  admission: AdmissionRequirementValue;
  preliminaryCheck: PreliminaryCheck;
  isFullTime: boolean;
  isPhd: boolean;
  isViewMode: boolean;
  refetchAdmission: () => void;
};

export const programmeMap: Record<string, ProgrammeTypes[]> = {
  'MPhil-2': [
    ProgrammeTypes.TWO_YEAR_FULL_TIME_MPHIL,
    ProgrammeTypes.FOUR_YEAR_PART_TIME_MPHIL,
  ],
  'MPhil-4': [ProgrammeTypes.FOUR_YEAR_PART_TIME_MPHIL],
  'PhD-3': [
    ProgrammeTypes.THREE_YEAR_FULL_TIME_PHD,
    ProgrammeTypes.SIX_YEAR_PART_TIME_PHD,
  ],
  'PhD-6': [ProgrammeTypes.SIX_YEAR_PART_TIME_PHD],
  'PhD-4': [
    ProgrammeTypes.FOUR_YEAR_FULL_TIME_PHD,
    ProgrammeTypes.EIGHT_YEAR_PART_TIME_PHD,
  ],
  'PhD-8': [ProgrammeTypes.EIGHT_YEAR_PART_TIME_PHD],
};

export function getProgrammeType(
  programmeLevel: string,
  duration: number,
): ProgrammeTypes[] {
  return programmeMap[`${programmeLevel}-${duration}`] ?? [];
}
